import { isAnyArray } from 'is-any-array';
import { getOutputArray } from './getOutputArray';
/**
 * This function xMultiply the first array by the second array or a constant value to each element of the first array
 * @param array1 - first array
 * @param array2 - second array
 * @param options - options
 */
export function xMultiply(array1, array2, options = {}) {
    let isConstant = false;
    let constant = 0;
    if (isAnyArray(array2)) {
        if (array1.length !== array2.length) {
            throw new Error('size of array1 and array2 must be identical');
        }
    }
    else {
        isConstant = true;
        constant = Number(array2);
    }
    const array3 = getOutputArray(options.output, array1.length);
    if (isConstant) {
        for (let i = 0; i < array1.length; i++) {
            array3[i] = array1[i] * constant;
        }
    }
    else {
        for (let i = 0; i < array1.length; i++) {
            array3[i] = array1[i] * array2[i];
        }
    }
    return array3;
}
//# sourceMappingURL=xMultiply.js.map